export default __webpack_public_path__ + "static/media/provesional_restoration_upper_47_2@2x.37fb3401.png";